import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { TextEditModule } from 'Angular/features/components/modals/text-edit/text-edit.module';
import * as i0 from "@angular/core";
export class TextEditModalModule {
}
TextEditModalModule.ɵfac = function TextEditModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TextEditModalModule)(); };
TextEditModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TextEditModalModule });
TextEditModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ModalBaseModule, TextEditModule] });
